var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAntenLogoNewLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470 100",
    style: {
      enableBackground: "new 0 0 470 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#CCCCCC;}\n\t.st2{fill:#B2B2B2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mono__x7C__Light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wordmark_2_",
    className: "st0",
    d: "M426.9,77.5V41.1c0-1.5,1.2-2.8,2.7-2.8h21.9c1.5,0,2.7,1.3,2.7,2.8v36.4 c0,1.5-1.2,2.8-2.7,2.8h-21.9C428.1,80.3,426.9,79.1,426.9,77.5z M413.1,3.8v22.4c0,1.5,1.2,2.8,2.7,2.8h49.4 c1.5,0,2.7-1.3,2.7-2.8V3.8c0-1.5-1.2-2.8-2.7-2.8h-49.4C414.4,1,413.1,2.3,413.1,3.8z M360.1,43h-21.9c-1.5,0-2.7,1.3-2.7,2.8v6.5 h-41.1v-6.5c0-1.5-1.2-2.8-2.7-2.8h-21.9c-1.5,0-2.7,1.3-2.7,2.8v20.5c0,2.6-2,4.7-4.6,4.7H244c-2.5,0-4.6-2.1-4.6-4.7V45.8 c0-1.5-1.2-2.8-2.7-2.8h-21.9c-1.5,0-2.7,1.3-2.7,2.8v20.5c0,18,14.3,32.7,32,32.7h18.3c12.7,0,23.8-7.6,28.9-18.7h53.4 c2.5,0,4.6-2.1,4.6-4.7c0,2.6,2,4.7,4.6,4.7h47.5c1.5,0,2.7-1.3,2.7-2.8V55.1c0-1.5-1.2-2.8-2.7-2.8h-38.4v-6.5 C362.9,44.3,361.6,43,360.1,43z M253.1,29c7.6,0,13.7-6.3,13.7-14c0-7.7-6.1-14-13.7-14c-7.6,0-13.7,6.3-13.7,14 C239.4,22.7,245.6,29,253.1,29z M383.4,29c7.6,0,13.7-6.3,13.7-14c0-7.7-6.1-14-13.7-14s-13.7,6.3-13.7,14 C369.7,22.7,375.9,29,383.4,29z M305.5,29c4.1,0,7.8-1.8,10.3-4.8c2.5,2.9,6.2,4.8,10.3,4.8c7.6,0,13.7-6.3,13.7-14 c0-7.7-6.1-14-13.7-14c-4.1,0-7.8,1.8-10.3,4.8c-2.5-2.9-6.2-4.8-10.3-4.8c-7.6,0-13.7,6.3-13.7,14C291.8,22.7,297.9,29,305.5,29z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyph_2_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 29.1,
    cy: 52.3,
    rx: 27.4,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 93.1,
    cy: 52.3,
    rx: 27.4,
    ry: 28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 157.1,
    cy: 52.3,
    rx: 27.4,
    ry: 28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenLogoNewLight);
export default __webpack_public_path__ + "static/media/anten-logo-new-light.d1f58e701ba2eeadca0d1e70297faa7a.svg";
export { ForwardRef as ReactComponent };